'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getAfterStyle = exports.getAfterStyle = function getAfterStyle() {
  return {
    display: 'table',
    clear: 'both'
  };
};

var getAfterContentStyle = exports.getAfterContentStyle = function getAfterContentStyle() {
  return {
    display: 'none'
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-grid-system/build/utilities/ClearFix/style.js
// module id = 396
// module chunks = 213534597649335